
import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { MdOutlineBlock, MdSearch, MdMode, MdDelete, MdRemoveRedEye, MdDownload, MdClose } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sort from '../../assets/image/sort-down-alt.svg';
import Filter from '../../assets/image/filter.svg';
import Dummy from '../../assets/image/user-circle.svg';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import fileCSV from '../../assets/File/Coach.xlsx'
import demppic from "../../assets/image/user-circle.svg"
import Loader from '../../Components/Loader/Loader';

const CoachList = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Access the location object

    const storedState = JSON.parse(localStorage.getItem("coachManagementState")) || {};

    const [totalPages, setTotalPages] = useState(storedState.totalPages || 0);
    const [total, setTotal] = useState(storedState.total || 0);
    const [page, setPage] = useState(storedState.page || 1);
    const [perPage, setPerPage] = useState(storedState.perPage || 10);
    const [search, setSearch] = useState(storedState.search || "");
    const [indexNumber, setIndexNumber] = useState(storedState.indexNumber || 0);
    const [id, setId] = useState(0);
    const [user, setUser] = useState([]);
    const [delet, setDelet] = useState(false);
    const deleteClose = (e) => { e.preventDefault(); setDelet(false); }
    const [block, setBlock] = useState(false);
    const blockClose = () => setBlock(false);
    const [addSubAdmin, setAddSubAdmin] = useState(false);
    const subAdminClose = () => setAddSubAdmin(false);
    const subAdminShow = () => setAddSubAdmin(true);
    const [activeTab, setActiveTab] = useState('Primary');
    const [switchtab, setSwitchTab] = useState(false);
    const [ViewStatus, setViewStatus] = useState()
    const [status, setStatus] = useState()
    const [loading, setLoading] = useState(true)

    // Preserve the state when opening modals
    const [modalState, setModalState] = useState(null); // Store location state or any other data you need

    // Use location.state if available, otherwise fallback to default
    const locationState = location.state || {};

    useEffect((e) => {
        // Store the location state in local state to preserve it
        if (location.state) {

            setModalState(location.state); // Save it in a local state
        }
    }, [location.state, delet]);

    const deleteShow = async (e, id) => {
        e.preventDefault()
        setId(id);
        setDelet(true);
    };




    const getUserList = async () => {
        const response = await handleApiCall("get", `${endpoint.CoachList}?page=${page}&limit=${perPage}&search_query=${search}&filter_data=${encodeURIComponent(JSON.stringify(filter_data))}`, {});
        try {
            console.log(response, "Coach============>>>>>")
            if (response?.data?.code === 200) {
                setLoading(false)
                setUser(response?.data?.data?.coachList);
                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
            if (response?.response?.data?.success === false) {
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
        } catch (e) {
            console.log("Error fetching data:", e);
        }
    };
    const handleBlock = async () => {

        const response = await handleApiCall("put", `${endpoint.updateCoach}`, {
            id: id,
            status: status
        });
        try {
            console.log(response, "Update STatus...................")
            if (response?.data?.code === 200) {
                setBlock(false);
                getUserList();
                toast.success(response?.data?.message);
                // setPage(1);
                // setIndexNumber(0);
                // setTotal(0);

            }
            else {
                setBlock(false);
                getUserList();
                toast.error(response?.response?.data?.errorMessage || "Technical Issue Please Try Again Later");

            }
        } catch (error) {
            console.log("Error deleting user:", error);
            setDelet(false);
            getUserList();
            toast.success(response?.data?.message);
        }
    };



    const handleDelete = async (e) => {
        e.preventDefault()
        const response = await handleApiCall("delete", `${endpoint.deleteUser}`, {
            userId: id,
        });
        try {
            if (response?.data?.code === 200) {
                setDelet(false);
                getUserList();
                toast.success(response?.data?.message);
                setPage(1);
                setIndexNumber(0);
                setTotal(0);

            }
            else {
                setDelet(false);
                getUserList();
                toast.error(response?.data?.message || "Technical Issue Please Try Again Later");

            }
        } catch (error) {
            console.log("Error deleting user:", error);
            setDelet(false);
            getUserList();
            toast.success(response?.data?.message);
        }
    };

    const paginationHandler = (e, i) => {
        e.preventDefault();
        if (i !== page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1);
            setIndexNumber(newIndexNumber);
        }
    };

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            event.target.value = ""; // 👈 Reset the input value
        }
    };

    const handleFileDelete = () => {
        setSelectedFile(null)
        setDelet(false)
    }

    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a CSV file to upload.");
            return;
        }
        setLoading(true)

        const formData = new FormData();
        formData.append("csvFile", selectedFile);

        try {
            const response = await handleApiCall("post", endpoint.uploadCSVCoach, formData);
            console.log(response?.response?.data?.errorMessage, "upload file")
            if (response?.data?.code === 200) {
                setDelet(false)
                setLoading(false)
                toast.success("File uploaded successfully!");
                getUserList()
                selectedFile(null)



            }

            else {
                toast.error(response?.response?.data?.message || response?.response?.data?.errorMessage);
                selectedFile(null)
                setLoading(false)
                setDelet(false)
            }
        } catch (error) {
            setDelet(false)
            setLoading(false)
            console.error("Error adding school:", error);

        }
    };

    useEffect(() => {
        if (selectedFile) {
            setTimeout(() => {
                setDelet(true)
            }, 500);

        }

    }, [selectedFile])
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = fileCSV;
        link.setAttribute('download', 'Coach.xlsx'); // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const [regionList, setRegionList] = useState([]);
    const [regionIds, setRegionIds] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [countryIds, setCountryIds] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [stateIds, setStateIds] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [districtIds, setDistrictIds] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [blockIds, setBlockIds] = useState([]);

    // Prevent dropdown from closing on selection
    const [openDropdown, setOpenDropdown] = useState(null);

    useEffect(() => { getRegionList(); }, []);
    useEffect(() => { if (regionIds.length) getCountryList(); else setCountryList([]); }, [regionIds]);
    useEffect(() => { if (countryIds.length) getStateList(); else setStateList([]); }, [countryIds]);
    useEffect(() => { if (stateIds.length) getDistrictList(); else setDistrictList([]); }, [stateIds]);
    useEffect(() => { if (districtIds.length) getBlockList(); else setBlockList([]); }, [districtIds]);

    const toggleSelection = (id, setState, currentState) => {
        setState(
            currentState.includes(id)
                ? currentState.filter(item => item !== id) // Remove if already selected
                : [...currentState, id] // Add if not selected
        );
    };

    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterRegion}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };

    const getCountryList = async () => {
        try {
            console.log("regionIds before sending:", regionIds);
            console.log("Type of regionIds:", typeof regionIds);
            // Convert regionIds array to a proper JSON array string
            const queryParam = JSON.stringify(regionIds);

            const response = await handleApiCall("get", `${endpoint.filterCountry}?region_id=${queryParam}`);
            if (response?.data?.code === 200) {
                setCountryList(response.data.data);
            }
        } catch (e) {
            console.log("Error fetching country list:", e);
        }
    };
    const getStateList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterState}?country_id=${JSON.stringify(countryIds)}`, {});
            if (response?.data?.code === 200) setStateList(response.data.data);
        } catch (e) { console.log("Error fetching state list:", e); }
    };

    const getDistrictList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterDistrict}?state_id=${JSON.stringify(stateIds)}`, {});
            if (response?.data?.code === 200) setDistrictList(response.data.data);
        } catch (e) { console.log("Error fetching district list:", e); }
    };

    const getBlockList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterBlock}?district_id=${JSON.stringify(districtIds)}`, {});
            if (response?.data?.code === 200) setBlockList(response.data.data);
        } catch (e) { console.log("Error fetching block list:", e); }
    };

    const [filter_data, setfilter_data] = useState({
        region_id: regionIds,
        country_id: countryIds,
        state_id: stateIds,
        district_id: districtIds,
        block_id: blockIds
    })

    useEffect(() => {
        setfilter_data({
            region_id: regionIds,
            country_id: countryIds,
            state_id: stateIds,
            district_id: districtIds,
            block_id: blockIds
        });
    }, [regionIds, countryIds, stateIds, districtIds, blockIds]);



    const resetFilters = () => {
        setRegionIds([]);
        setCountryIds([]);
        setStateIds([]);
        setDistrictIds([]);
        setBlockIds([]);
    };



    // Common function for navigation (view/edit)
    const handleNavigation = (path, data) => {
        localStorage.setItem(
            "coachManagementState",
            JSON.stringify({
                totalPages,
                total,
                page,
                perPage,
                search,
                indexNumber,
                filter_data,
            })
        );
        navigate(path, { state: { ...data, fromPage: true } });
    };


    const [hasRestoredState, setHasRestoredState] = useState(false);
    const isRestoringState = useRef(true);

    // Restore state when navigating back from view/edit
    useEffect(() => {
        if (location.state?.fromPage) {
            const savedState = JSON.parse(localStorage.getItem("coachManagementState"));
            if (savedState) {
                setTotalPages(savedState.totalPages);
                setTotal(savedState.total);
                setPage(savedState.page);
                setPerPage(savedState.perPage);
                setSearch(savedState.search);
                setIndexNumber(savedState.indexNumber);
                setfilter_data(savedState.filter_data || {});

                // ✅ Restore IDs for filters from saved filter_data
                setRegionIds(savedState.filter_data?.region_id || []);
                setCountryIds(savedState.filter_data?.country_id || []);
                setStateIds(savedState.filter_data?.state_id || []);
                setDistrictIds(savedState.filter_data?.district_id || []);
                setBlockIds(savedState.filter_data?.block_id || []);
            }
            localStorage.removeItem("coachManagementState");
        }

        // ⏳ Delay state trigger until all state has synced
        setTimeout(() => {
            isRestoringState.current = false;
            setHasRestoredState(true);
        }, 0);
    }, [location.state]);
    // ✅ Debounced Search (AFTER restoration)
    useEffect(() => {
        if (isRestoringState.current || !hasRestoredState) return;

        const timer = setTimeout(() => {
            setPage(1);
            setIndexNumber(0);
            setTotal(0);
            getUserList();
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    // ✅ Page & PerPage change
    useEffect(() => {
        if (!hasRestoredState || isRestoringState.current) return;
        getUserList();
    }, [page, perPage]);

    // ✅ Filter change — only after restore
    useEffect(() => {
        if (!hasRestoredState || isRestoringState.current) return;
        setPage(1);
        setIndexNumber(0);
        setTotal(0);
        getUserList();
    }, [filter_data]);

    // ✅ Trigger only once after restore (no double API calls)
    useEffect(() => {
        if (hasRestoredState && !isRestoringState.current) {
            getUserList();
        }
    }, [hasRestoredState]);




    return (
        <>
            <Loader isLoading={loading} /> {/* Call Loader */}
            <Tab.Container id="left-tabs-example" defaultActiveKey="Profile">
                 <div className='flex flex-wrap gap-2 items-center justify-center sm:justify-start'>
                                <button onClick={resetFilters} className="bg-[#F0D7E0] py-2 px-4 mb-2  rounded-md font-bold text-[15px]">All</button>
                                {[
                                    { name: "Region", list: regionList, ids: regionIds, setState: setRegionIds },
                                    { name: "Country", list: countryList, ids: countryIds, setState: setCountryIds },
                                    { name: "State", list: stateList, ids: stateIds, setState: setStateIds },
                                    { name: "District", list: districtList, ids: districtIds, setState: setDistrictIds },
                                    { name: "Block", list: blockList, ids: blockIds, setState: setBlockIds }
                                ].map(({ name, list, ids, setState }) => (
                                    <Dropdown
                                        key={name}
                                        className="mb-2"
                                        show={openDropdown === name}
                                        onToggle={(isOpen) => setOpenDropdown(isOpen ? name : null)}
                                    >
                                        <Dropdown.Toggle
                                            variant="light"
                                            className="text-dark w-full sm:w-auto"
                                            style={{ backgroundColor: "#F0D7E0", border: "0", borderRadius: "5px", fontSize: "15px", fontWeight: "bold" }}
                                        >
                                            {ids.length ? `${name}` : name}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {list.length === 0 ? (
                                                <Dropdown.Item disabled>No {name} available</Dropdown.Item>
                                            ) : (
                                                list.map((item) => (
                                                    <Dropdown.Item key={item._id} as="div" className="d-flex align-items-center">
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={ids.includes(item._id)}
                                                            onChange={() => toggleSelection(item._id, setState, ids)}
                                                            label={item.name}
                                                            className="text-black"
                                                            style={{ fontSize: "15px" }}
                                                        />
                                                    </Dropdown.Item>
                                                ))
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                ))}
                            </div>
                <div className='row align-items-center'>
                    <div className='my-3  w-full px-2 sm:px-4'>
                        <div className='flex flex-col sm:flex-row justify-between gap-2'>
                            <label className="relative block w-full sm:w-auto">
                                <span className="sr-only">Search</span>
                                <div className="relative w-full">
                                    <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                                        <svg className="h-5 w-5 fill-slate-500" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                        </svg>
                                    </span>
                                    <input
                                        className="placeholder:text-gray-400 block bg-gray-200 rounded-md w-full border border-slate-300 py-2.5 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-base"
                                        placeholder="Search"
                                        type="text"
                                        name="Search"
                                        value={search}
                                        maxLength={150}
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            // Remove leading spaces or special characters
                                            value = value.replace(/^[\s\W_]+/, "");

                                            setSearch(value);
                                        }}
                                    />
                                </div>
                            </label>
                           
                            <div className='flex flex-wrap gap-2 justify-center sm:justify-start'>
                                <button
                                    onClick={handleDownload}
                                    className="text-[#994263] py-2 font-bold inline-flex cursor-pointer justify-center px-3 items-center hover:bg-[#e6e0e2] border-[#994263] rounded-md border-[2px] w-full sm:w-auto"
                                >
                                    CSV Template
                                </button>
                                <input
                                    type="file"
                                    accept=".csv, .xls, .xlsx"
                                    onChange={handleFileChange}
                                    className="hidden"
                                    id="fileUpload"
                                />
                                <label htmlFor="fileUpload" className="text-[#994263] py-2 font-bold inline-flex cursor-pointer justify-center px-3 items-center hover:bg-[#e6e0e2] border-[#994263] rounded-md border-[2px] w-full sm:w-auto">
                                    Upload CSV
                                </label>
                                <div
                                    onClick={() => navigate("/coach-management/add-coach")}
                                    className="text-white font-bold inline-flex cursor-pointer py-2 justify-center px-3 items-center hover:bg-[#f589b3] border-[#994263] bg-[#994263] rounded-md border-[2px] w-full sm:w-auto"
                                >
                                    +Add Coach
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="common-table-wrapper m-0">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th className=' text-center'>Sr.No.</th>
                                    <th>Coach Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Gender</th>
                                    <th>Program ID</th>
                                    <th>PO/PA Name</th>
                                    <th>Region</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>District</th>
                                    <th>Block</th>
                                    <th className=" text-center">Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr className="justify-center">
                                        <td colSpan="100%">
                                            <h6 className="text-center text-lg">Loading...</h6>
                                        </td>
                                    </tr>
                                ) : user.length > 0 ? (
                                    user.map(({ _id, full_name, po_pa, email, phone, gender, program_id, state_name, region_name, country_name, country_code, image, district_name, block_name, status, country_id, district_id, state_id, region_id, block_id }, i) => {
                                        return (
                                            <tr key={_id}>
                                                <td className=' text-center'> {indexNumber + i + 1}</td>
                                                <td>
                                                    <div className="flex items-center gap-2 text-center mr-4 cursor-pointer"
                                                    
                                                    onClick={() => handleNavigation("/coach-management/view-coach", { id: _id })}>
                                                        <div className="w-[35px] h-[35px] rounded-full overflow-hidden flex-shrink-0"
                                                         
                                                        >
                                                            <img
                                                          
                                                                src={image || demppic}
                                                                alt={full_name || 'Profile'}
                                                                className="w-full h-full object-cover"
                                                            />
                                                        </div>
                                                        <span>{full_name || "-"}</span>
                                                    </div>
                                                </td>

                                                <td>{email || "-"}</td>
                                                <td>{country_code + "-" + phone || "-"}</td>
                                                <td>{gender}</td>
                                                <td>{program_id || "-"}</td>
                                                <td>{po_pa || "-"}</td>
                                                <td>{region_name || "-"}</td>
                                                <td>{country_name || "-"}</td>
                                                <td>{state_name || "-"}</td>
                                                <td>{district_name || "-"}</td>
                                                <td>{block_name || "-"}</td>
                                                <td className="action-tab flex justify-center gap-2">
                                                    <button
                                                        onClick={() => handleNavigation("/coach-management/view-coach", { id: _id })}
                                                        className="action-icon view-info bg-slate-300 rounded-full p-1"
                                                    >
                                                        <MdRemoveRedEye style={{ width: "17px", height: "17px" }} />
                                                    </button>

                                                    {/* Edit Coach Button */}
                                                    <button
                                                        onClick={() =>
                                                            handleNavigation("/coach-management/add-coach", {
                                                                _id,
                                                                full_name,
                                                                email,
                                                                po_pa,
                                                                phone,
                                                                gender,
                                                                program_id,
                                                                image,
                                                                state_name,
                                                                region_name,
                                                                country_name,
                                                                district_name,
                                                                block_name,
                                                                status,
                                                                country_id,
                                                                country_code,
                                                                district_id,
                                                                state_id,
                                                                region_id,
                                                                block_id,
                                                                screen: "edit",
                                                            })
                                                        }
                                                        className="action-icon view-info bg-slate-300 rounded-full p-1"
                                                    >
                                                        <MdMode style={{ width: "17px", height: "17px" }} />
                                                    </button>
                                                    <label className="inline-flex items-center cursor-pointer blockSwitch">
                                                        <input type="checkbox"
                                                            checked={status === 1}
                                                            onClick={() => {
                                                                setViewStatus(status);
                                                                setId(_id);
                                                                setStatus(status === 1 ? 0 : 1);
                                                                setBlock(true);
                                                            }}
                                                            className="peer hidden"
                                                        />
                                                        <div className="relative w-11 h-6 bg-[#E4002B] peer-focus:outline-none rounded-full peer dark:bg-[#E4002B] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[3px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-500"></div>
                                                    </label>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr className="justify-center">
                                        <td colSpan="100%">
                                            <h6 className="text-center text-lg">No Coach Found.</h6>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <Row className=" px-2 mb-4 py-2">
                        <Col md={12}>
                            <Pagination
                                data={user}
                                indexNumber={indexNumber}
                                totalPage={totalPages}
                                setPage={setPage}
                                page={page}
                                paginationHandler={paginationHandler}
                                total={total}
                            />
                        </Col>
                    </Row>
                </div>

                <Toastify />
            </Tab.Container>

            {/* Delete Modal */}
            <Modal dialogClassName="modal-custom-sm" centered show={delet} onHide={deleteClose}>
                <Modal.Body className='p-0'>
                    <div className="card logout-card common_box">
                        <div className="card-body common_box_body py-4 px-3">
                            <p className="modalTitle text-center mb-2 fw-bold">Are you sure you want to<br />upload this File?</p>
                            <div className="btn-wrapper text-center">
                                <Link className="btn btn-form btn-cancel" onClick={handleFileDelete}>No</Link>
                                <Link className="btn btn-form btn-add" onClick={(e) => handleUpload(e)}>Yes</Link>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Other Modals */}
            <Modal dialogClassName="modal-custom-sm" centered show={block} onHide={blockClose}>
                <Modal.Body className='p-0'>
                    <div className="card logout-card common_box">
                        <div className="card-body common_box_body py-4 px-3">
                            <p className="modalTitle text-center mb-2 fw-bold">Are you sure you want to<br />{ViewStatus === 0 ? "Activate " : "Deactivate  "}this Coach?</p>
                            <div className="btn-wrapper text-center">
                                <Link className="btn btn-form btn-cancel" onClick={blockClose}>No</Link>
                                <Link className="btn btn-form btn-add" onClick={handleBlock}>Yes</Link>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal dialogClassName="modal-dialog-414" centered show={addSubAdmin} onHide={subAdminClose}>
                <Modal.Body className="p-0">
                    <div className="card logout-card common_box">
                        <div className="card-body p-0">
                            <Form className="custom_form">
                                <div className="py-4 px-4">
                                    <p className="modalMainTitle text-center mb-3">Add sub-admin</p>
                                    <Link className="close-modal" onClick={subAdminClose}><MdClose /></Link>
                                    {/* Sub-admin form fields */}
                                    <Form.Group className="mb-3 cf_label" controlId="Contest Name">
                                        <label htmlFor="" className='px-2 mb-1 opacity-50'>Sub-Admin Name</label>
                                        <Form.Control className="cf_input rounded-pill" type="text" placeholder="Name" value="Jhonathan" />
                                    </Form.Group>

                                    <Form.Group className="mb-3 cf_label" controlId="no fo team">
                                        <label htmlFor="" className='px-2 mb-1 opacity-50'>Email</label>
                                        <Form.Control className="cf_input rounded-pill" type="text" placeholder="Email" value="jhon@mail.com" />
                                    </Form.Group>

                                    <Form.Group className="mb-3 cf_label" controlId="Entry Fee">
                                        <label htmlFor="" className='px-2 mb-1 opacity-50'>Assign Profile</label>
                                        <Form.Select aria-label="Default select example" className="cf_input rounded-pill">
                                            <option>Profile</option>
                                            <option value="1">Profile 01</option>
                                            <option value="2">Profile 02</option>
                                            <option value="3">Profile 03</option>
                                            <option value="4">Profile 04</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <div className="btn-wrapper text-center gap-3">
                                        <Link className="btn btn-form btn-cancel rounded-pill w-50" onClick={subAdminClose}>No</Link>
                                        <Link className="btn btn-form btn-add rounded-pill w-50" onClick={subAdminClose}>Add</Link>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};

export default CoachList;
